var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M20.787 5.247a.249.249 0 01.4.194V13.9a1.987 1.987 0 01-1.987 1.991H1.986A1.987 1.987 0 010 13.9V5.446a.248.248 0 01.4-.195c.927.72 2.156 1.635 6.377 4.7.873.637 2.346 1.978 3.816 1.97 1.477.012 2.98-1.357 3.82-1.97 4.222-3.065 5.447-3.984 6.374-4.704zm-10.193 5.347c.96.017 2.342-1.208 3.038-1.713 5.492-3.985 5.91-4.333 7.176-5.326a.99.99 0 00.381-.782v-.786A1.987 1.987 0 0019.2 0H1.986A1.987 1.987 0 000 1.986v.786a1 1 0 00.381.782c1.266.989 1.684 1.341 7.176 5.326.695.506 2.077 1.731 3.037 1.714z","fill":"currentColor","key":1})]);
}

Mail.defaultProps = {"viewBox":"0 0 21.188 15.891"};

module.exports = Mail;

Mail.default = Mail;
